export const CRAZY_WEEKEND_API = {
  homepage: '/live/activity/game_week_homepage',
  rank: '/live/activity/game_week_rank',
} as const

export const CRAZY_WEEKEND_RANK_LIMIT = 10
